import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { ErrorContext } from '../utils/constants';
import {makeStyles} from "@material-ui/core/styles";
import Colors from "../utils/colors";

export const ErrorProvider = ErrorContext.Provider;

const useStyles = makeStyles(() => ({
  btnClass: {
    backgroundColor: Colors.darkBlue,
  },
}));

export default function ErrorDialog({title, description, open, onRetry, onClose}) {
  const classes = useStyles();
    const onClickRetry = () => {
        onRetry();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {onRetry && <Button
                    onClick={onClickRetry}
                    variant="contained"
                    color="primary"
                    className={classes.btnClass}
                >
                    RETRY
                </Button>}
                <Button
                    onClick={onClose}
                    variant='contained'
                    color='primary'
                    className={classes.btnClass}
                >
                    CONTINUE
                </Button>
            </DialogActions>
        </Dialog>
    );
}
